import { atu, map as mapEndpoints } from '../../../api/api-endpoints.js'
import MappingDrawer                from '../utils/MappingDrawer'
import MappingBorderDrawer          from '../utils/MappingBorderDrawer'
import { OBJECT }                   from '@/utils/map/types'
import L                            from 'leaflet'
import 'leaflet.vectorgrid'
import 'leaflet-plugins/layer/tile/Yandex'

import { DEFAULT_OPACITY, FORMED_POPUP, POP_POPUP, VILLAGE_ZOOM_ARR, ZONES } from '../config/config'
import { MAP, MARKER_ICON }                                                  from '@/config/map'
import ObjectCardLinkCreator
                                                                             from '@/utils/map/layer/ObjectCardLinkCreator'
import { WALL }                                                              from '@/config/config'

const rosreestr_prefix = 'https://pkk.rosreestr.ru/'

export default {
  data() {
    return {
      selectedMappingObject:     null,
      selectedMappingObjectZoom: null,
      showEquidistantGeo:        null,
      radiusEquidistant:         null,
      radiusEquidistantGeo:      1000,
      equidistantPoint:          {
        id:   'click',
        type: OBJECT.EQUIDISTANT,
        lat:  undefined,
        lng:  undefined
      },
      cadastreTile:              null,
      legendItems:               null,
      rosreestrTiles:            {
        cadastreLines: new L.LayerGroup([
                                          new L.VectorGrid.Protobuf(
                                            rosreestr_prefix + 'arcgis/rest/services/Hosted/caddivsion/VectorTileServer/tile/{z}/{y}/{x}.pbf', {
                                              rendererFactory:       L.svg.tile,
                                              interactive:           false,
                                              pane:                  'cadastre',
                                              minZoom:               3,
                                              vectorTileLayerStyles: {
                                                'Кадастровые округа:1':       {
                                                  weight:      1,
                                                  fillOpacity: 1,
                                                  fillColor:   '#d20305',
                                                  color:       '#d20305'
                                                },
                                                'Кадастровые округа:2':       {
                                                  weight:      1,
                                                  fillOpacity: 1,
                                                  fillColor:   '#d20305',
                                                  color:       '#d20305'
                                                },
                                                'Кадастровые районы:1':       {
                                                  weight:      1,
                                                  fillOpacity: 1,
                                                  fillColor:   '#d20305',
                                                  color:       '#d20305'
                                                },
                                                'Кадастровые районы:2':       {
                                                  weight:      1,
                                                  fillOpacity: 1,
                                                  fillColor:   '#d20305',
                                                  color:       '#d20305'
                                                },
                                                'Кадастровые кварталы':       {
                                                  weight:      1,
                                                  fillOpacity: 1,
                                                  fillColor:   '#d20305',
                                                  color:       '#d20305'
                                                },
                                                'Кадастровые округа:1/label': {
                                                  stroke: false
                                                },
                                                'Кадастровые округа:2/label': {
                                                  stroke: false
                                                },
                                                'Кадастровые районы:1/label': {
                                                  stroke: false
                                                },
                                                'Кадастровые районы:2/label': {
                                                  stroke: false
                                                },
                                                'Кадастровые кварталы/label': {
                                                  stroke: false
                                                }
                                              }
                                            }
                                          )
                                        ]),
        osm:           new L.LayerGroup([], { pane: 'osm' }),
        yandex:        new L.LayerGroup([L.yandex()], { pane: 'yandex' }),
        satellite:     new L.LayerGroup([L.yandex('yandex#satellite')], { pane: 'yandex' })
      }
    }
  },
  computed: {
    mappingConfObject() {
      return {
        population: {
          title:   'Население',
          legends: [
            {
              endpoint: mapEndpoints.heatMapPopulationDistrict,
              valueKey: 'population',
              popup:    POP_POPUP,
              style:    {
                opacity: DEFAULT_OPACITY
              },
              items:    [
                { title: '1-25 тыс.', min: 0, style: { color: '#fad089' } },
                { title: '25-50 тыс.', min: 25000, style: { color: '#ff9c5b' } },
                { title: '50-75 тыс.', min: 50000, style: { color: '#f5634a' } },
                { title: '75-100 тыс.', min: 75000, style: { color: '#ed313c' } },
                { title: 'от 100 тыс.', min: 100000, style: { color: '#a8016d' } }
              ]
            },
            {
              // hideLegend: true,
              showOnZoom: VILLAGE_ZOOM_ARR,
              valueKey:   'population',
              endpoint:   mapEndpoints.heatMapPopulationSettlement,
              popup:      POP_POPUP,
              style:      {
                opacity: DEFAULT_OPACITY
              },
              items:      [
                { title: '1-25 тыс.', min: 0, style: { fillColor: '#fad089', color: '#ff9c5b' } },
                { title: '25-50 тыс.', min: 25000, style: { fillColor: '#ff9c5b', color: '#ff9c5b' } },
                { title: '50-75 тыс.', min: 50000, style: { fillColor: '#f5634a', color: '#ff9c5b' } },
                { title: '75-100 тыс.', min: 75000, style: { fillColor: '#ed313c', color: '#ff9c5b' } },
                { title: 'от 100 тыс.', min: 100000, style: { fillColor: '#a8016d', color: '#ff9c5b' } }
              ]
            }
          ]
        },
        formed:     {
          title:   'Количество образованных отходов',
          legends: [
            {
              endpoint: mapEndpoints.heatMapFormedDistrict,
              valueKey: 'formed',
              popup:    FORMED_POPUP,
              style:    {
                opacity: DEFAULT_OPACITY
              },
              items:    [
                { title: '1-25 тыс.', min: 0, style: { color: '#74db54' } },
                { title: '25-50 тыс.', min: 25000, style: { color: '#bbe668' } },
                { title: '50-100 тыс.', min: 50000, style: { color: '#f6e548' } },
                { title: '100-250 тыс.', min: 100000, style: { color: '#ffc90e' } },
                { title: 'от 250 тыс.', min: 250000, style: { color: '#ed313c' } }
              ]
            },
            {
              // hideLegend: true,
              showOnZoom: VILLAGE_ZOOM_ARR,
              style:      {
                opacity: DEFAULT_OPACITY
              },
              endpoint:   mapEndpoints.heatMapFormedSettlement,
              valueKey:   'formed',
              popup:      FORMED_POPUP,
              items:      [
                { title: '1-25 тыс.', min: 0, style: { color: '#74db54' } },
                { title: '25-50 тыс.', min: 25000, style: { color: '#bbe668' } },
                { title: '50-100 тыс.', min: 50000, style: { color: '#f6e548' } },
                { title: '100-250 тыс.', min: 100000, style: { color: '#ffc90e' } },
                { title: 'от 250 тыс.', min: 250000, style: { color: '#ed313c' } }
              ]
            }
          ]
        },
        [ZONES]:    {
          title:   'Зоны деятельности региональных операторов',
          legends: [
            {
              endpoint:   mapEndpoints.heatMapRegOperators(this.$route?.query?.zoom || MAP.zoom),
              popup:      {
                head:   'Зона действия',
                fields: [
                  { value: 'apoName', label: 'Наименование' },
                  { value: 'name_with_type', label: 'Район' },
                  { value: 'operatorName', label: 'Региональный оператор' },
                  { value: 'total_garbage', label: 'Количество образованных отходов, тонн' },
                  { value: 'total_garbage_cubic', label: 'Количество образованных отходов, м³' },
                  { value: 'total_garbage_processing', label: 'Количество переработанных отходов, тонн' },
                  { value: 'total_garbage_cubic_processing', label: 'Количество переработанных отходов, м³' },
                  { value: 'cnt', label: 'Количества источников образования отходов' },
                  { value: 'total_garbage_storage', label: 'Количество захороненных  отходов, тонн' },
                  { value: 'total_garbage_cubic_storage', label: 'Количество захороненных  отходов, м³' },
                  { value: 'apoTotalGarbageSum', label: 'Количество образованных отходов по всей зоне, тонн' },
                  { value: 'apoTotalGarbageCubicSum', label: 'Количество образованных отходов по всей зоне, м³' },
                  {
                    value: 'tariffLimitForecastValue',
                    label: 'Прогнозное значение предельного тарифа на текущий регулируемый период, руб'
                  },
                  { value: 'tariff_processing', label: 'Тариф на обработку ТКО' },
                  { value: 'tariff_neutralization', label: 'Тариф на обезвреживание ТКО' },
                  { value: 'tariff_burial', label: 'Тариф на захоронение ТКО' },
                  { value: 'tariff_collection', label: 'Цена на сбор ТКО' },
                  { value: 'tariff_transportation', label: 'Цена на транспортирование ТКО' },
                  { value: 'tariff_regop_common', label: 'Единый тариф на услугу Регионального оператора' }
                ]
              },
              valueKey:   false,
              hideLegend: true,
              items:      [
                { min: 0 }
              ]
            }
          ]
        }
      }
    },
    mappingCurrentLegend() {
      let currentOnZoom = null
      if (this.selectedMappingObject && this.selectedMappingObjectZoom) {
        let zoom    = this.selectedMappingObjectZoom
        let current = this.mappingConfObject[this.selectedMappingObject]
        current.legends.forEach(v => {
          if (v.hasOwnProperty('showOnZoom') && v.showOnZoom.indexOf(zoom) > -1) {
            currentOnZoom = v
          } else if (!currentOnZoom) {
            currentOnZoom = v
          }
          if (currentOnZoom) {
            if (!v.title) {
              currentOnZoom.title = current.title
            }
            currentOnZoom.items.forEach((item, i) => {
              currentOnZoom.items[i].style = Object.assign(
                currentOnZoom.items[i].style || {},
                v.style || {}
              )
            })
          }
        })
      }
      
      return currentOnZoom || {}
    },
    radius() {
      return this.radiusEquidistant
    }
  },
  mounted() {
    this.mappingDrawer = new MappingDrawer(this.map, this)
    this.map.createPane('cadastre')
    this.map.createPane('osm')
    this.map.createPane('yandex')
    this.$emitter.listen('searchRosreestr', this.searchRosreestr)
    this.$emitter.listen('whatisit', ({ latlng: { lat, lng } }) => this.searchRosreestr(`${lat},${lng}`))
    this.$emitter.listen('copyObjectCardLinkToClipboard', ({ id, subLayerConfig }) => {
      this.copyObjectCardLinkToClipboard(id, subLayerConfig)
    })
    this.$emitter.listen('eqClickPolygon', polygon => this.modifyEqPolygon(polygon))
    this.setMappingObjectFromRoute()
  },
  methods: {
    copyObjectCardLinkToClipboard(id, subLayerConfig) {
      const link = ObjectCardLinkCreator.createLink(id, subLayerConfig)
      link && navigator.clipboard.writeText(link).then(() => {
        this.$message({
                        message:  'Ссылка скопирована в буфер',
                        type:     'success',
                        duration: WALL.SUCCESS_TIMEOUT
                      })
      })
    },
    async modifyEqPolygon(polygon) {
      if (!this.showEquidistantGeo) {
        await this.borderDrawer.clearEqPoly()
        return
      }
      //TODO поставить debugger для отладки Эквидистанты населенного пункта
      const data = await this.$store.dispatch('updateUrlEndpoint', {
        endpoint: atu.equidistant(polygon.id, this.radiusEquidistantGeo)
      })
      await this.borderDrawer.clearEqPoly()
      this.borderDrawer.drawPolygon(data.data)
      this.borderDrawer.addEqPolygonClick(polygon.id, this.radiusEquidistantGeo)
    },
    setEquidistantGeo(value) {
      this.radiusEquidistantGeo = value
    },
    setShowEquidistantGeo(show) {
      this.showEquidistantGeo = show
    },
    async searchRosreestr(q) {
      try {
        await this.getInfoFromRosreestr(q).then(({ data }) => {
          console.log(data);
          if (!data || data.lat === 0.0) {
            this.$e.warningBox('Ничего не найдено')
            return
          }
          this.$e.warningBox(`Осталось ${data.queryAttempts} запросов на сегодня. Запросы расходуются при поиске по адресу или координатам в Росреестре. `)
          this.openRosreestrPopup(data)
        })
      } catch (e) {
        this.$e.errorBox(e)
      } finally {
        this.$bar.finish()
      }
    },
    openRosreestrPopup(data) {
      if (!this.map) {
        return
      }
      const latLng = L.latLng(data.lat, data.lng)
      const marker = L.marker(latLng, {
        icon: MARKER_ICON
      })
      
      if (this.map.getZoom() >= 17) {
        this.map.panTo(latLng)
      } else {
        const markerBounds = L.latLngBounds([marker.getLatLng()])
        this.map.fitBounds(markerBounds, { maxZoom: 17 })
      }
      
      const popup = L.popup({
                              maxWidth:     1000,
                              maxHeight:    1000,
                              className:    'tooltip tooltip--top',
                              bottomOffset: 50
                            }).setLatLng(latLng).setContent(this.composeRosreestrPopupContent(data))
      marker.bindPopup(popup).addTo(this.map).openPopup()
    },
    composeRosreestrPopupContent(data) {
      let result = `<p>
                  <h1>${data.address || data.type + ', адрес не найден'}</h1>
                   Кадастровый номер: <b>${data.cadasterNumber || ' - '}</b><br>
                   Тип: <b>${data.type || ' - '}</b><br>
                   Координаты: <b>${data.lat + ', ' + data.lng}</b><br>`
      if (data.area) {
        result += `Площадь: <b>${data.area}</b><br>`
      }
      result += '</p>'
      return result
    },
    async getInfoFromRosreestr(q) {
      return await this.$store.dispatch('updateUrlEndpoint', {
        endpoint: mapEndpoints.searchRosreestr({ query: { q } })
      })
    },
    updateEquidistantCircle(radius) {
      this.radiusEquidistant = radius
    },
    drawBorders() {
      this.borderDrawer = new MappingBorderDrawer(this.map, this)
      this.borderDrawer.drawAll(this.getMapPolygon(), this.mapBorders)
      this.borderDrawer.drawLocality(this.mapBorders, true)
    },
    async onMappingCurrentLegend() {
      this.mappingDrawer.clearPoly()
      this.borderDrawer.detachPopups()
      await this.fetchMappingLegendData(this.mappingCurrentLegend).then(() => {
        this.borderDrawer.attachPopups(this.mappingCurrentLegend)
      })
    },
    async fetchMappingLegendData(legend) {
      if (!legend?.endpoint) {
        this.mappingLock()
        this.mappingDrawer.clearPoly()
        this.mappingUnLock()
        return Promise.resolve()
      }

      const endpoint = typeof legend?.endpoint === 'function' ? legend.endpoint(this.$route) : legend.endpoint
      if (this.mappingDrawer.isPolyDrawed(endpoint)) {
        return
      }
      this.mappingLock()
      let data = this.$store.getters.readUrlEndpoint(endpoint)
      if (!data) {
        this.$bar.start()
        const res = await this.$store.dispatch('updateUrlEndpoint', {
          endpoint,
          notReactive: true
        })
        data      = res.data
        this.$bar.finish()
      }
      try {
        this.mappingDrawer.setPolyData(data, legend, endpoint)
      } catch (e) {
        console.error(e)
        this.$store.commit('mutateError', e)
      }
      this.mappingUnLock()
    },
    mappingLock() {
      this.lockRoute()
      this.layersLoading = true
    },
    mappingUnLock() {
      this.layersLoading = false
      this.unLockRoute()
      this.updateRouteStateFromMap()
    },
    async setSelectedMappingObject(v) {
      this.selectedMappingObject = v;
      if (!v) {
        await this.replaceRoute({ selectedMappingObject: null });
        await this.onMappingCurrentLegend();
        return;
      }
      await this.replaceRoute({ selectedMappingObject: v })
      const endpoint = mapEndpoints.mapLegend(v, this.$route.query.zoom)
      if (endpoint) {
        this.$store.dispatch('updateUrlEndpoint', {
          endpoint,
          notReactive: true,
          fromCache:   true
        }).then(res => this.legendItems = res.data.data)
      }
      await this.onMappingCurrentLegend()
    },
    setMappingObjectFromRoute() {
      this.setSelectedMappingObject(this.$route?.query?.selectedMappingObject)
      this.selectedMappingObjectZoom = Number.parseInt(this.$route.query.zoom || this.map.getZoom() * 1)
    },
    // клик по карте от Эквидистанты .. 
    equidistantEventClick(e) {
      this.equidistantPoint.lat = e.latlng.lat
      this.equidistantPoint.lng = e.latlng.lng
      
      this.mappingDrawer.removeMarker(this.equidistantPoint)
      this.mappingDrawer.removeCircle(this.equidistantPoint)
      this.mappingDrawer.drawMarker(this.equidistantPoint)
      this.mappingDrawer.drawCircle(this.equidistantPoint, parseInt(this.radius, 10))
    },
    // вызов попопа по контекстному меню ... 
    equidistantEventContextmenu() {
      // точку не поставили .. надо выйти ...
      if (typeof this.equidistantPoint.lat == 'undefined' || typeof this.equidistantPoint.lng == 'undefined') {
        return ;
      }
      this.mappingDrawer.removeMarker(this.equidistantPoint);
      const marker                = this.mappingDrawer.drawMarker(this.equidistantPoint)
      marker.type                 = OBJECT.EQUIDISTANT
      marker.options.popupOptions = {
        redirectParams: {
          name:  'equidistant.object',
          query: {
            radius:    this.radius,
            longitude: this.equidistantPoint.lng,
            latitude:  this.equidistantPoint.lat,
            layers:    this.$route.query.layers
          }
        }
      }
      this.mappingDrawer.createPopup(marker);
    },
    onShowEquidistant(show) {
      if (show) {
        this.map.on('click', this.equidistantEventClick);
        this.map.on('contextmenu', this.equidistantEventContextmenu);
      } else {
        this.map.off('click', this.equidistantEventClick);
        this.map.off('contextmenu', this.equidistantEventContextmenu);
        this.mappingDrawer.removeMarker(this.equidistantPoint)
        this.mappingDrawer.removeCircle(this.equidistantPoint)
        this.equidistantPoint.lat = this.equidistantPoint.lng = undefined;
      }
    },
    onRosreestrChangeView(value) {
      switch (value) {
        case 'rosreestr_cadastre': {
          this.map.hasLayer(this.rosreestrTiles.osm) && this.map.removeLayer(this.rosreestrTiles.osm)
          this.map.hasLayer(this.rosreestrTiles.yandex) && this.map.removeLayer(this.rosreestrTiles.yandex)
          this.map.removeLayer(this.rosreestrTiles.satellite)
          this.map.addLayer(this.rosreestrTiles.cadastreLines)
          this.map.getPane('osm').style.display      = 'none'
          this.map.getPane('yandex').style.display   = 'none'
          this.map.getPane('cadastre').style.display = 'block'
          break
        }
        case 'osm': {
          this.map.removeLayer(this.rosreestrTiles.cadastreLines)
          this.map.removeLayer(this.rosreestrTiles.yandex)
          this.map.removeLayer(this.rosreestrTiles.satellite)
          this.map.addLayer(this.rosreestrTiles.osm)
          this.map.getPane('cadastre').style.display = 'none'
          this.map.getPane('yandex').style.display   = 'none'
          this.map.getPane('osm').style.display      = 'block'
          break
        }
        case 'yandex': {
          this.map.removeLayer(this.rosreestrTiles.cadastreLines)
          this.map.removeLayer(this.rosreestrTiles.osm)
          this.map.removeLayer(this.rosreestrTiles.satellite)
          this.map.addLayer(this.rosreestrTiles.yandex)
          this.map.getPane('cadastre').style.display = 'none'
          this.map.getPane('osm').style.display      = 'none'
          this.map.getPane('yandex').style.display   = 'block'
          break
        }
        case 'satellite': {
          this.map.removeLayer(this.rosreestrTiles.cadastreLines)
          this.map.removeLayer(this.rosreestrTiles.osm)
          this.map.removeLayer(this.rosreestrTiles.yandex)
          this.map.addLayer(this.rosreestrTiles.satellite)
          this.map.getPane('cadastre').style.display = 'none'
          this.map.getPane('osm').style.display      = 'none'
          this.map.getPane('yandex').style.display   = 'block'
          break
        }
      }
    }
  }
}
